"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const pascalCase = (input) => {
  const camelCased = input.replace(/(?:-|_)(\w)/g, (_, c) => {
    return c ? c.toUpperCase() : "";
  });
  return camelCased[0].toUpperCase() + camelCased.slice(1);
};
exports.pascalCase = pascalCase;
//# sourceMappingURL=pascalCase.cjs.map
